import { Injectable } from "@angular/core";
import { McticHttpClient } from "@mctic/ng-core";
import { Observable } from "rxjs";
import { SecurityService } from "./security.service";
import { AnoBase } from "../shared/model/ano-base.model";

@Injectable({
  providedIn: 'root'
})

export class AnoBaseService {

  private readonly endpoint = '/sepin-backend/rest/ano-base';

  constructor(private readonly http: McticHttpClient,
              private readonly securityService: SecurityService) {
  }

  obterAnoBaseConfigurado(anoBase: number): Observable<AnoBase> {
    return this.http.get<AnoBase>(`${this.endpoint}/${anoBase}/configurado`);
  }

  obterAnoBaseUsuario(idUsuario: number): Observable<AnoBase[]> {
    return this.http.get<AnoBase[]>(`${this.endpoint}/usuario/${idUsuario}`);
  }

  obterAnoBaseAutenticado(): AnoBase {
    return this.securityService.usuarioSessao.anoBase;
  }

}
